import { cn } from "@/lib/utils";

/**
 * M33 — a page's filter row, pinned just under the app header so changing a filter never
 * means scrolling back to the top.
 *
 * The offset is `--app-header-h`, published by AppShell from a ResizeObserver — the header's
 * height is variable (iOS safe-area inset, the health strip wrapping or expanding), so any
 * hardcoded top would misalign exactly on Andy's phone. The fallback only covers the frame
 * before the first measurement lands.
 *
 * `-mx-4 px-4` spans main's gutters so page content cannot peek through at the sides while
 * scrolling under the translucent background. z-20 sits below the app header (z-30) and the
 * bottom nav (z-40).
 */
export function StickySubheader({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        "sticky top-[var(--app-header-h,3.25rem)] z-20 -mx-4 space-y-3 bg-background/95 px-4 pb-2 backdrop-blur",
        className,
      )}
    >
      {children}
    </div>
  );
}
